import { Card, Collapse, GridLegacy } from "@mui/material";
import React, { useMemo } from "react";
import CardBody from "../../../../components/Card/CardBody";
import { convertObjectToSelectOptions } from "../../../../templateHelpers";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useController, useFormContext, useWatch } from "react-hook-form";
import MenuSyncSettings from "../MenuSyncSettings";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";

function Lightspeed() {
  const orderMode = useMemo(
    () => [
      { value: "TABLE", label: "On table" },
      { value: "ORDER", label: "Order mode" },
    ],
    []
  );

  const {
    field: { value: lightspeedUseOAuth, onChange: lightspeedUseOAuthOnChange },
  } = useController({ name: "apiaccounts__lightspeedUseOAuth" });
  const orderModeOptions = useMemo(() => convertObjectToSelectOptions(orderMode), []);
  const { menukaartVestigingId } = useFormContext();
  const currentOrderMode = useWatch({ name: "lightspeedOrderMode" });

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Lightspeed"} tKey={"vestigingen.form.lightspeed.headers.lightspeed"} />
              </h3>
            </GridLegacy>
            <FormSwitchTC
              name={"apiaccounts__useTest"}
              tDefault={"Gebruik test omgeving"}
              tKey={"vestigingen.form.apiaccounts.label.useTest"}
            />
            <FormSwitchTC
              name={"apiaccounts__lightspeedUseOAuth"}
              tDefault={"Gebruik OAuth koppeling"}
              tKey={"vestigingen.form.apiaccounts.label.lightspeedUseOAuth"}
            />
          </GridLegacy>
          <Collapse in={!lightspeedUseOAuth}>
            <GridLegacy container spacing={1}>
              <FormTextTC
                name={"lightspeedUser"}
                tDefault={"Gebruiker"}
                tKey={"vestigingen.form.lightspeed.label.lightspeedUser"}
              />
              <FormTextTC
                name={"lightspeedCompanyID"}
                tDefault={"Company ID"}
                tKey={"vestigingen.form.lightspeed.label.lightspeedCompanyID"}
              />
              <FormTextTC
                name={"lightspeedUrl"}
                tDefault={"Server"}
                tKey={"vestigingen.form.lightspeed.label.lightspeedUrl"}
              />
            </GridLegacy>
          </Collapse>
          <GridLegacy container spacing={1}>
            <FormSelectTC
              name={"lightspeedOrderMode"}
              options={orderModeOptions}
              tDefault={"Order mode"}
              tKey={"vestigingen.form.lightspeed.label.orderMode"}
            />
            {currentOrderMode == "ORDER" ? (
              <>
                <FormSwitchTC
                  defaultValue={false}
                  name={"custom_data.lightspeed.eatin_as_table_order"}
                  tDefault={"Create order on table when using eat-in"}
                  tKey={"vestigingen.form.overige.label.eatin_as_table_order"}
                />
                <FormTextTC
                  name={"custom_data.lightspeed.eatin_order_table"}
                  tDefault={"Table to create order on"}
                  tKey={"vestigingen.form.lightspeed.label.eatin_order_table"}
                />
              </>
            ) : null}
            <FormSwitchTC
              name={"custom_data.lightspeed.use_static_customer"}
              tDefault={"Don't create new customer for every order"}
              tKey={"vestigingen.form.lightspeed.label.use_static_customer"}
            />
            <FormTextTC
              name={"lightspeedPayId"}
              tDefault={"Payment id"}
              tKey={"vestigingen.form.lightspeed.label.lightspeedPayId"}
            />
            <FormTextTC
              name={"lightspeedPayTypeId"}
              tDefault={"Payment type id"}
              tKey={"vestigingen.form.lightspeed.label.lightspeedPayTypeId"}
            />
            <FormTextTC
              defaultProps={{ placeholder: "1234,4321,2134" }}
              name={"lightspeedDOpt"}
              tDefault={"Disable options"}
              tKey={"vestigingen.form.lightspeed.label.lightspeedDOpt"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
            <FormSwitchTC
              name={"useWithoutTableOverlappingMiddleware"}
              tDefault={"Don't overlap table request"}
              tKey={"vestigingen.form.overige.label.useWithoutTableOverlappingMiddleware"}
            />
            <FormSwitchTC
              name={"oChecker"}
              tDefault={"Order checker"}
              tKey={"vestigingen.form.overige.label.orderChecker"}
            />
            <FormSwitchTC
              name={"mplusOCnt"}
              tDefault={"Send OCnt"}
              tKey={"vestigingen.form.mplusapi.label.mplusOCnt"}
            />
          </GridLegacy>

          <MenuSyncSettings />
        </CardBody>
      </Card>
    </div>
  );
}

export default Lightspeed;
